define('contentUtils',['helpers'], function(helpers) {
    'use strict';

    var contentUtils,
        expandTimeoutID;

    function ContentUtils(options) {
        options = options || {};

        this.delay = options.delay || 0;
        this.mobile = options.mobile || {};

        this.flexible = false;
        this.enclosed = false;
        this.columns = true;

        this.layoutHeader = document.getElementById('header');
        this.layoutMain = document.getElementById('content');
        this.layoutContent = document.getElementById('js-layout-content');

        this.updateProperties();
    }

    ContentUtils.prototype.updateProperties = function() {
        var flexible = window.getComputedStyle(document.body, ':after').getPropertyValue('content').replace(/"/g, ''),
            enclosed = window.getComputedStyle(document.body, ':before').getPropertyValue('content').replace(/"/g, ''),
            columns = window.getComputedStyle(document.getElementById('player'), ':after').getPropertyValue('content').replace(/"/g, '');

        this.flexible = (flexible && flexible === 'js-flex') ? true : false;
        this.enclosed = (enclosed && enclosed === 'js-enclosed') ? true : false;
        this.columns = (columns && columns === 'js-cols') ? true : false;
    };

    ContentUtils.prototype.touchContent = function() {
        var content = document.getElementById('js-layout-content'),
            nodes = (content) ? content.querySelectorAll('textarea, input, button, select, [tabindex]') : null,
            i = (nodes) ? nodes.length : 0;

        while (i--) {
            nodes[i].focus();
        }

        if (content) {
            content.focus();
        }
    };

    ContentUtils.prototype.imitateFlexbox = function() {
        var _this = this,
            minHeight = 0,
            layoutLast = document.getElementById('js-layout-flex');

        if (_this.layoutMain && layoutLast) {
            minHeight = _this.layoutMain.clientHeight - layoutLast.offsetTop - parseInt(helpers.layout.nodeStyle(_this.layoutContent, 'paddingBottom'));
            layoutLast.style.minHeight = (this.flexible && this.columns) ? minHeight + 'px' : 0;
        }
    };

    ContentUtils.prototype.expandContent = function() {
        var _this = this;

        if (expandTimeoutID) {
            window.clearTimeout(expandTimeoutID);
        }

        if (!_this.enclosed || !this.columns) {
            return;
        }

        expandTimeoutID = setTimeout(function() {
            var heightBody = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
                height = (_this.layoutContent.clientHeight > _this.layoutMain.clientHeight) ? Math.min(_this.layoutContent.clientHeight, (heightBody - _this.layoutHeader.clientHeight - 80)) : 0;

            if (height) {
                _this.layoutMain.style.height = height + 'px';
            }

        }, this.delay);
    };

    ContentUtils.prototype.shrinkContent = function() {
        var _this = this;

        if (_this.layoutMain) {
            _this.layoutMain.style.height = '';
        }
    };

    ContentUtils.prototype.resizeContent = function() {
        var _this = this;

        if (!_this.enclosed) {
            if (expandTimeoutID) {
                window.clearTimeout(expandTimeoutID);
            }

            if (!_this.mobile.enabled || this.columns) {
                _this.shrinkContent();
            }
        } else {
            _this.expandContent();
        }

    };

    return function(options) {

        if (!contentUtils) {
            contentUtils = new ContentUtils(options);
        }

        return contentUtils;

    };

});

